// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toBoolean = (value: any) => (value as string) === 'true';

export const ENV_TAG = process.env.REACT_APP_ENV_TAG as string;
export const BASE_URL = process.env.REACT_APP_API_BASE_URL as string;
export const SEGMENT_WRITE_KEY_EE = process.env.REACT_APP_SEGMENT_WRITE_KEY_EE as string;
export const SEGMENT_WRITE_KEY_KE = process.env.REACT_APP_SEGMENT_WRITE_KEY_KE as string;
export const CORS_ALLOW_CREDENTIALS = toBoolean(process.env.REACT_APP_CORS_ALLOW_CREDENTIALS);
